import { SystemRoutes } from "./RouteUtils";
import { hasPermission } from "../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../Config/Constants";

export enum HomeScreenKey {
    OVERVIEW = "OVERVIEW",
    SYNOPTIC = "SYNOPTIC",
    PERFORMANCE = "PERFORMANCE",
    ALARMS = "ALARMS",
    ACTIVE_POWER = "ACTIVE_POWER",
    UNAVAILABILITY = "UNAVAILABILITY",
    MAP = "MAP"
}

export interface HomeScreenOption {
    key: HomeScreenKey;
    label: string;
    route: SystemRoutes;
    authorities: string[];
}

export const HOME_SCREEN_OPTIONS: HomeScreenOption[] = [
    {
        key: HomeScreenKey.OVERVIEW,
        label: "Visão Geral",
        route: SystemRoutes.DASHBOARD_OVERVIEW,
        authorities: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD, AUTHORITIES.VIEW_DASHBOARD_CHART]
    },
    {
        key: HomeScreenKey.SYNOPTIC,
        label: "Sinóptico",
        route: SystemRoutes.DASHBOARD_OVERVIEW_SYNOPTIC,
        authorities: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD_SYNOPTIC]
    },
    {
        key: HomeScreenKey.PERFORMANCE,
        label: "Performance",
        route: SystemRoutes.DASHBOARD_OVERVIEW_PERFORMANCE,
        authorities: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD_PERFORMANCE]
    },
    {
        key: HomeScreenKey.ALARMS,
        label: "Alarmes",
        route: SystemRoutes.DASHBOARD_OVERVIEW_ALARMS,
        authorities: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD_ALARM]
    },
    {
        key: HomeScreenKey.ACTIVE_POWER,
        label: "Potência Ativa",
        route: SystemRoutes.DASHBOARD_OVERVIEW_ACTIVE_POWER,
        authorities: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD_ACTIVE_POWER]
    },
    {
        key: HomeScreenKey.UNAVAILABILITY,
        label: "Disponibilidade DIN/DEX",
        route: SystemRoutes.DASHBOARD_OVERVIEW_UNAVAILABILITY,
        authorities: [AUTHORITIES.SYSADMIN, AUTHORITIES.MANAGE_UNAVAILABILITY]
    },
    {
        key: HomeScreenKey.MAP,
        label: "Mapa",
        route: SystemRoutes.DASHBOARD_OVERVIEW_MAP,
        authorities: [AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD]
    }
];

export const DEFAULT_HOME_SCREEN = HomeScreenKey.OVERVIEW;
export const DEFAULT_HOME_ROUTE = SystemRoutes.DASHBOARD_OVERVIEW;

type AuthorityLike = { name?: string | null } | null | undefined;

const findOption = (key?: string | null): HomeScreenOption | undefined =>
    HOME_SCREEN_OPTIONS.find(option => option.key === key);

export const getAvailableHomeScreens = (
    authorities: Array<AuthorityLike> | null | undefined
): HomeScreenOption[] =>
    HOME_SCREEN_OPTIONS.filter(option => hasPermission(authorities, option.authorities));

export const resolveHomeRoute = (
    homeScreen: string | null | undefined,
    authorities: Array<AuthorityLike> | null | undefined
): string => {
    const option = findOption(homeScreen);
    if (option && hasPermission(authorities, option.authorities)) {
        return option.route;
    }
    const available = getAvailableHomeScreens(authorities);
    const defaultOption = available.find(o => o.key === DEFAULT_HOME_SCREEN);
    if (defaultOption) {
        return defaultOption.route;
    }
    return available.length > 0 ? available[0].route : DEFAULT_HOME_ROUTE;
};
